import { IMAGES } from "@/components/landing/images";

export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[580px] lg:min-h-[660px] flex items-center justify-center text-center px-5 sm:px-8 py-20 overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Support worker assisting a participant in a warm Adelaide living room" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FAF8F5]/30 via-[#FAF8F5]/45 to-[#FAF8F5]" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto space-y-6">
        <p className="text-xs uppercase tracking-widest text-[#695A4C] font-semibold reveal">Registered NDIS Provider · South Australia</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-medium text-[#1A2328] leading-[1.15] text-balance reveal" style={{ animationDelay: "0.1s" }} data-testid="hero-headline">
          Support that shows up.
        </h1>
        <p className="text-lg sm:text-xl text-[#4A575E] leading-relaxed max-w-2xl mx-auto reveal" style={{ animationDelay: "0.2s" }}>
          A local, registered South Australian team offering personal attention, dependable daily care, and support coordination statewide.
        </p>
        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3 reveal" style={{ animationDelay: "0.3s" }}>
          <a href="#contact" data-testid="hero-book-button" className="w-full sm:w-auto px-7 py-3.5 rounded-full text-base font-medium text-[#FAF8F5] bg-[#223036] hover:bg-[#141E22] transition-colors shadow-sm">
            Book an Appointment
          </a>
          <a href="#contact" data-testid="hero-enquiry-button" className="w-full sm:w-auto px-7 py-3.5 rounded-full text-base font-medium text-[#323E44] bg-[#EFE7DC] hover:bg-[#E4D9CC] transition-colors">
            Send an Enquiry
          </a>
        </div>
        <p className="text-xs text-[#6B7980] reveal" style={{ animationDelay: "0.4s" }}>Direct calendar booking with instant confirmation · No referral fee</p>
      </div>
    </section>
  );
}
